/**
 * 비품(Equipment) 리듀서 — 비품 히스토리(읽기 전용 리스트) 상태.
 * (EQUIPMENT_INOUT_SPEC §6)
 *
 * 비품 마스터/inventories 는 기존 item 리듀서(state.item.items.equipments)에 그대로 두고,
 * adjust/transfer 후에는 _getItems 재호출로 갱신(saga). 여기서는 히스토리만 보관.
 *
 * 비용현황(report)도 히스토리 집계 기반이므로 동일 슬라이스 사용 가능.
 */

import * as actions from "../actions";

const initialState = {
  histories: [],
  count: 0,
  status: { isFetching: false, error: null },
};

export default function equipment(state = initialState, action) {
  switch (action.type) {
    case actions.GET_EQUIPMENT_HISTORIES:
      return { ...state, status: { isFetching: true, error: null } };
    case actions.RECEIVE_EQUIPMENT_HISTORIES:
      return {
        ...state,
        histories: action.histories || [],
        count: action.count || 0,
        status: { isFetching: false, error: null },
      };
    case actions.SET_EQUIPMENT_HISTORIES_FAILURE:
      return {
        ...state,
        status: { isFetching: false, error: action.error },
      };
    default:
      return state;
  }
}
